export default {"src":"/_next/static/media/hud.cf6669ba.svg","height":100,"width":200,"blurWidth":0,"blurHeight":0};